export const CHAT_STRATEGY = 'local_rag';
export const MAX_SSE_BUFFER_SIZE = 1024 * 1024;
export const INPUT_GUARDRAIL_BLOCKED_EVENT = 'INPUT_GUARDRAIL_BLOCKED';
export const OUTPUT_GUARDRAIL_BLOCKED_EVENT = 'OUTPUT_GUARDRAIL_BLOCKED';

// // Ignore internal AG-UI events that should not be shown in chat. Exclude RUN_ERROR so user-facing error messages are still displayed.
export const IGNORED_AGUI_EVENT_TYPES = [
    'RUN_STARTED',
    'RUN_FINISHED',
    'STEP_STARTED',
    'STEP_FINISHED',
    'TEXT_MESSAGE_START',
    'TEXT_MESSAGE_END',
    'TOOL_CALL_START',
    'TOOL_CALL_ARGS',
    'TOOL_CALL_END',
    'TOOL_CALL_RESULT',
    'STATE_SNAPSHOT',
    'STATE_DELTA',
    'MESSAGES_SNAPSHOT'
];
